<div id="main">
  <div class="fof">
    <h1>Error 404 - Unable to find the page</h1>
  </div>
</div>
